export const SET_UNREAD_MESSAGE_SUPPORT_EDNA =
  'SET_UNREAD_MESSAGE_SUPPORT_EDNA' as const

export const setUnreadMessageSupportEdnaAction = (value: number) => ({
  value,
  type: SET_UNREAD_MESSAGE_SUPPORT_EDNA,
})
